import Theme from 'Theme';
import styled, { keyframes } from 'styled-components';

import config from 'config';
import Card from 'components/common/Card';

const baseName = config.site.baseName;

const zoomInRotate = keyframes`
  0% {
    opacity: 0;
    transform: scale(0, 0) rotate(0deg); 
  }
  80% {
    transform: scale(1.1, 1.1) rotate(360deg); 
  }
  100% {
    transform: scale(1.0, 1.0) rotate(360deg); 
  }
`;

const fadeIn = keyframes`
  0% {
    transform: translateX(20px); 
    opacity: 0;
  }
  60% {
    transform: translateX(-5px); 
  }
  100% {
    transform: translateX(0px); 
    opacity: 1;
  }
`;

export const Header = styled.div`
  margin-bottom: 8px;
`;

export const Title = styled.h1`
  margin: 0px;
  font-size: 32px;
  font-weight: 400;
  margin-bottom: 8px;
  color: ${Theme.successColor}
  font-family: ${Theme.primaryFont};
`;

export const Text = styled.div`
  font-size: 14px;
  font-family: ${Theme.primaryFont};
`;

export const Container = styled.div`
  width: 100%;
  display: flex;
  margin-top: 64px;
  align-items: center;
  justify-content: center;
`;

export const FormContain = styled.div`

`;

export const StyledCard = styled(Card.Content)`
  width: 540px;
`;

export const SearchLightLogo = styled.img`
  max-height: 50px;

  animation-delay: 0.2s;
  animation-duration: 0.5s;
  transform: scale(0, 0);
  animation-name: ${zoomInRotate};
  animation-fill-mode: forwards;
  animation-timing-function:  ease-out;
`;

SearchLightLogo.defaultProps = {
  src: `${baseName ? '/' : ''}${baseName}/img/logo.png`
};

export const SearchLightText = styled.img`
  max-height: 70px;
  transform: translateX(50px); 

  opacity: 0;
  margin-left: 16px;
  animation-delay: 0.2s;
  animation-duration: 0.5s;
  animation-name: ${fadeIn};
  animation-fill-mode: forwards;
  animation-timing-function:  ease-out;
`;

SearchLightText.defaultProps = {
  src: `${baseName ? '/' : ''}${baseName}/img/searchlight.png`
};

export const PaddingContain = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
`;
